function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.4 11.8C11.3 4.59 7.8 0 6.8 0 5.6 0 2.2 4.6 2 11.7a1.84 1.84 0 00-2 1.8v5.8a1.14 1.14 0 001.8 1.1l.5-.3a2.84 2.84 0 001-.9c.1-.1.2-.3.3-.4v-.1c.1-.1.1-.2.2-.4v-.1c0-.1.1-.2.1-.4v-.1c0-.2.1-.3.1-.5.1.1.3.1.5.2s.2.1.3.1a3.59 3.59 0 001.1.2h1.5a3.19 3.19 0 001.4-.3c.2-.1.3-.1.5-.2a.9.9 0 00.1.5v.1c0 .1.1.2.1.3a.1.1 0 00.1.1c.1.1.1.2.2.4a.1.1 0 00.1.1 2.78 2.78 0 001.2 1.2l.5.3c1 .5 1.8.1 1.8-1l.1-5.8a2.09 2.09 0 00-2.1-1.6zm-4.7-1.5a2.11 2.11 0 01-2.1-2.1 2.05 2.05 0 012.1-2.1 2.05 2.05 0 012.1 2.1 2.11 2.11 0 01-2.1 2.1z",
  fill: "#202020"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.5 20.59"
  }, props), _ref);
};

export default SvgComponent;